import { BaseUrl } from '../../types';
import { createAxiosClient, type RequestConfig, type ResponseConfig } from '../../utils/createAxiosClient';
import { getBaseUrl } from '../../utils/getBaseUrl';

export { type RequestConfig };
export type ResponseErrorConfig<TData = unknown> = ResponseConfig<TData>;

const baseUrl: BaseUrl = {
  production: 'https://dip-component.home-finance-underwriting.pfida.com',
  development: 'https://dip-component.home-finance-underwriting.dev.pfida.com',
};

export const dipComponentClient = createAxiosClient({ baseURL: getBaseUrl(baseUrl), serviceName: 'DIP_COMPONENT' });
export default dipComponentClient;
